import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

export default function CustomDatePicker({ setFieldValue, dateValue,disabled }) {
  const [value, setValue] = React.useState(dateValue || null);
  const handleDateChange = (newValue) => {
    if (newValue) {
      const dateObject = newValue.toDate(); // Convert to JavaScript Date object so that Yup.date() can validate.
      setValue(dateObject);
      setFieldValue("dob", dateObject);
    } else {
      setValue(null);
      setFieldValue("dob", null);
    }
  };

  React.useEffect(() => {
    if (dateValue) {
      setValue(dateValue);
    }
  }, [dateValue]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          value={dayjs(value)}
          onChange={handleDateChange}
          format={value === null ? " " : "DD/MM/YYYY"}
          maxDate={dayjs()}
          slots={{
            textField: TextField,
          }}
          slotProps={{
            textField: {
              placeholder: "",
            },
          }}
          disabled={disabled}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
